export default "__VITE_ASSET__DdhHLsuY__"